import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getButtonSize = (cmp) => {
  switch (cmp.dsf_size) {
    case "small":
      return "h-24 w-24";
    case "minimal":
      return "h-12 w-12";
    default:
      return "h-32 w-32";
  }
};
const getIconClasses = (cmp) => {
  switch (cmp.dsf_size) {
    case "small":
      return "w-12 h-12";
    case "minimal":
      return "w-8 h-8";
    default:
      return "w-18 h-18";
  }
};
const getButtonStyles = (cmp) => {
  const classes = [
    cmp.dsf_size,
    getButtonSize(cmp),
    "rounded-full",
    "flex",
    "items-center",
    "justify-center",
    "z-2",
    cmp.dsf_size === "small" ? "dsf-text-xxs" : "dsf-text-xs"
  ];
  switch (cmp.dsf_state) {
    case "completed":
      classes.push(
        "focus-visible:shadow-focus-primary-sm",
        "outline-none",
        "dsf-text-xs",
        "border-primary-300",
        "text-neutral-0",
        "bg-primary-300",
        "hover:bg-primary-400",
        "hover:border-primary-400"
      );
      break;
    case "active":
      classes.push(
        "outline-none",
        "dsf-text-xs-semibold",
        "hover:text-primary-400",
        "focus-visible:shadow-focus-primary-sm",
        "hover:border-primary-400",
        "text-primary-300",
        "border-primary-300"
      );
      if (cmp.dsf_size === "minimal") {
        classes.push("border-3.5");
      } else {
        classes.push("border-3");
      }
      break;
    default:
      classes.push(
        "focus-visible:shadow-focus-neutral-sm",
        "outline-none",
        "dsf-text-xs",
        "text-neutral-700"
      );
      if (cmp.dsf_size === "minimal") {
        classes.push("bg-neutral-400", "hover:bg-neutral-500");
      } else {
        classes.push("border-2", "border-neutral-200", "hover:border-neutral-300");
      }
      break;
  }
  return concatClasses(classes);
};
export {
  getButtonStyles,
  getIconClasses
};
